module.exports = __webpack_public_path__ + "static/media/file-spreadsheet.11dece51.svg";